<template>
	<div 
		:class="['header-container', { 'is-home': $route.path === '/', 'is-scrolled': isScrolled || isHovered }]"
		@mouseenter="isHovered = true"
		@mouseleave="isHovered = false"
	>
		<el-row v-if="!isMobile">
		   <el-col>
			 <div class="nav">
				 <router-link to="/">
				 	<img height="100" alt="logo" src="../assets/logo.png">	
				 </router-link>	
				<el-menu background-color="transparent" :text-color="($route.path === '/' && !isScrolled && !isHovered) ? '#fff' : '#1E3A5F'" active-text-color="#F7941D" style="display: flex; flex-wrap:nowrap;" :default-active="activeIndex"  mode="horizontal" @select="handleSelect">
				  <el-submenu index="1"  style="width: 240px;" :popper-append-to-body="false">
					<template slot="title">
						<span class="menu">개인 회원</span>
					</template>
			<!-- 		<el-menu-item index="/documentStart">시작하기</el-menu-item>
					<el-menu-item index="/documentProcess">직구정보</el-menu-item>
					<el-menu-item index="/documentBenefit">혜택</el-menu-item>
					<el-menu-item index="/documentAwards">수상/보도</el-menu-item>
					<el-menu-item index="/documentReview">회원리뷰</el-menu-item> -->
					<el-menu-item index="/deliveryguide">
						<router-link to="/deliveryguide" class="menu-link">배송대행</router-link>
					</el-menu-item>
					<el-menu-item index="/deliveryPrice">
						<router-link to="/deliveryPrice" class="menu-link">배송요금</router-link>
					</el-menu-item>
					<el-menu-item index="/addService">
						<router-link to="/addService" class="menu-link">부가 서비스</router-link>
					</el-menu-item>
					<el-menu-item index="/customsInfo">
						<router-link to="/customsInfo" class="menu-link">통관안내</router-link>
					</el-menu-item>
					<!-- <el-menu-item index="/teamMoney">팀머니</el-menu-item> -->
				  </el-submenu>
				  <el-submenu index="2" style="width: 240px;" :popper-append-to-body="false">	  
					<template slot="title">
						<span class="menu">사업자 회원</span>
					</template>
					<el-menu-item index="/bizSupport">
						<router-link to="/bizSupport" class="menu-link">사업자 지원 안내</router-link>
					</el-menu-item>
					<el-menu-item index="/shoppingGuide">
						<router-link to="/shoppingGuide" class="menu-link">구매대행</router-link>
					</el-menu-item>
					<el-menu-item index="/inventoryGuide">
						<router-link to="/inventoryGuide" class="menu-link">재고/보관</router-link>
					</el-menu-item>
					<el-menu-item index="/payGuide">
						<router-link to="/payGuide" class="menu-link">대리결제</router-link>
					</el-menu-item>
					<el-menu-item index="/documentLcl">
						<router-link to="/documentLcl" class="menu-link">LCL화물운송</router-link>
					</el-menu-item>
					<el-menu-item index="/bizDeliveryGuide">
						<router-link to="/bizDeliveryGuide" class="menu-link">배송대행</router-link>
					</el-menu-item>
					<el-menu-item index="/deliveryPriceBiz">
						<router-link to="/deliveryPriceBiz" class="menu-link">배송요금</router-link>
					</el-menu-item>
					<el-menu-item index="/bizAddService">
						<router-link to="/bizAddService" class="menu-link">부가서비스</router-link>
					</el-menu-item>
					<el-menu-item index="/bizCustomsInfo">
						<router-link to="/bizCustomsInfo" class="menu-link">통관안내</router-link>
					</el-menu-item>
					<el-menu-item index="/bizTeamMoney">
						<router-link to="/bizTeamMoney" class="menu-link">로켓머니</router-link>
					</el-menu-item>
					
				  </el-submenu>
				  <!-- <el-submenu index="3" style="width: 240px;" :popper-append-to-body="false">
				  	<template slot="title">
				  		<span class="menu">Coupang</span>
				  	</template>
					<el-menu-item index="/inventoryCoupang">
						<router-link to="/inventoryCoupang" class="menu-link">그로스/로켓</router-link>
					</el-menu-item>
					
				  </el-submenu> -->
				  <el-submenu index="4" style="width: 240px;" :popper-append-to-body="false">
					<template slot="title">
						<span class="menu">고객센터</span>
					</template>
					<el-menu-item index="/noticeList">
						<router-link to="/noticeList" class="menu-link">공지사항</router-link>
					</el-menu-item>
					<el-menu-item index="/questionList">
						<router-link to="/questionList" class="menu-link">자주하는 질문</router-link>
					</el-menu-item>
					<el-menu-item index="/oneConsult">
						<router-link to="/oneConsult" class="menu-link">1:1 문의</router-link>
					</el-menu-item>
					<el-menu-item index="/documentInsure">
						<router-link to="/documentInsure" class="menu-link">안심보상</router-link>
					</el-menu-item>
					<el-menu-item index="/boardEvent">
						<router-link to="/boardEvent" class="menu-link">이벤트</router-link>
					</el-menu-item>
					<!-- <el-menu-item index="/partnership">
						<router-link to="/partnership" class="menu-link">제휴</router-link>
					</el-menu-item> -->
					
					<el-menu-item index="/documentSchedule">
						<router-link to="/documentSchedule" class="menu-link">배송일정</router-link>
					</el-menu-item>
					<el-menu-item index="/documentSize">
						<router-link to="/documentSize" class="menu-link">사이즈조건표</router-link>
					</el-menu-item>
					<el-menu-item>
						<a style="text-decoration: none;color:rgb(30, 58, 95);" href="https://www.baidu.com/s?ie=utf-8&amp;f=3&amp;rsv_bp=1&amp;rsv_idx=1&amp;tn=baidu&amp;wd=%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%9F%A5%E8%AF%A2&amp;fenlei=256&amp;oq=46%2526lt%253B762790550597&amp;rsv_pq=a89e0d0601495234&amp;rsv_t=2b7di9ZqS4gSqGPcd5BvaXjTJlsLJAsvkQcGKMAPHgUS5W7aO1Uv6ymheHk&amp;rqlang=cn&amp;rsv_dl=ts_0&amp;rsv_enter=0&amp;rsv_btype=t&amp;inputT=5993&amp;rsv_sug3=5&amp;rsv_sug1=2&amp;rsv_sug7=100&amp;rsv_sug2=1&amp;prefixsug=%25E5%25BF%25AB&amp;rsp=0&amp;rsv_sug4=5993&amp;rsv_sug=1" target="_blank">중국택배조회</a>
					</el-menu-item>
					<el-menu-item index="/documentAddress">
						<router-link to="/documentAddress" class="menu-link">나의 중국주소</router-link>
					</el-menu-item>
				  </el-submenu>

		<!-- 		  <el-menu-item index="3" class="menu">고객센터</el-menu-item> -->
				<!--  <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item> -->
				</el-menu>
				<div style="display: flex; flex-wrap:nowrap; gap: 15px; align-items: center;">
					<router-link to="/agencyShipping">
						<el-button size="mini" type="primary" style="width: 140px;height: 42px;font-size: 15px;font-weight: 600;background-color:#F7941D;border: none;">배송대행 신청</el-button>
					</router-link>
					<router-link to="/agencyShopping" v-if="token">
						<el-button size="mini" type="primary" style="width: 140px;height: 42px;font-size: 15px;font-weight: 600;background-color:#F7941D;border: none;">구매대행 신청</el-button>
					</router-link>
					<!--登录/注册-->
					<el-button v-if="!token" size="mini" style="width: 150px;height: 42px;font-size: 15px;font-weight: 600; border-color: #1E3A5F; color: #1E3A5F; background-color: #ffffff !important;" @click="onLogin" >로그인/회원 가입</el-button>
					<!--我的页面-->
					<el-dropdown v-else @command="handleCommand">
					<!--  <span class="el-dropdown-link">
					    下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
					  </span> -->
					<a href="/orderBundle">
				  	<el-button  size="mini" style="width: 140px;height: 42px;font-size: 15px;font-weight: 600;">마이페이지</el-button>
				    </a>
					  <el-dropdown-menu slot="dropdown">
					    <el-dropdown-item>
							<router-link to="/memberInfo" style="text-decoration: none; color: inherit; display: block;">회원정보 수정</router-link>
						</el-dropdown-item><!--编辑成员信息-->
					    <el-dropdown-item command="logout">로그아웃</el-dropdown-item><!--注销-->
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
				
			 </div> 
			 
		  </el-col>
		</el-row>
		<el-row v-else justify="space-between" align="middle" style="margin: 12px 8px;">
			<el-col :span="12">
				<router-link to="/">
					<img height="45" alt="logo" src="../assets/logo.png">
				</router-link>	
			</el-col>
			<el-col :span="12">
				<div style="display: flex;justify-content: right; align-items: center; gap: 10px;">
					<router-link to="/agencyShipping">
						<el-button size="mini" type="primary" style="width: 115px;height: 36px;font-size: 14px;font-weight: 600;background-color:#F7941D;border:none;">배송대행 신청</el-button>
					</router-link>
					<router-link to="/agencyShopping" v-if="token">
						<el-button size="mini" type="primary" style="width: 115px;height: 36px;font-size: 14px;font-weight: 600;background-color:#F7941D;border:none;">구매대행 신청</el-button>
					</router-link>
					<i @click="centerDialogVisible = true" class="el-icon-s-operation" style="font-size: 26px;"></i>
				</div>
			
			</el-col>
		</el-row>
		<el-dialog
		  :visible.sync="centerDialogVisible"
		   fullscreen 
		   destroy-on-close
		   :modal="false"
		   custom-class="mobile-drawer"
		  center>
		  <router-link style="position:absolute; top: 20px;" to="/">
		  	<img height="45" alt="logo" src="../assets/logo.png">
		  </router-link>	
		  <div class="user-wrap">
			  <div class="status-guest">
				  <div style="display: flex;justify-content: space-between;">
					  <div class="name">
						<div class="link-name">
							<i class="el-icon-user-solid"></i>
							    <span v-if="token" > {{nickname}} </span>
								<router-link to="/login" v-else @click.native="centerDialogVisible = false" style="text-decoration: none; color: inherit;">登录</router-link>
							<i class="el-icon-arrow-right"></i>
						</div>
					  </div>
					  
					  <div v-if="token" class="logout" @click="onLogout">
							로그아웃
					  </div>
				  </div>
				  <div class="mypage" v-if="token" >
					<router-link to="/orderBundle" style="text-decoration: none; color: inherit;">
					  마이페이지<!--我的页面-->
					</router-link>
					<router-link to="/memberInfo" style="text-decoration: none; color: inherit;">
						회원정보수정
					</router-link>
			<!-- 		  <router-link class="page-name" style="border-right: 1px solid #e8e8e8;" to="/orderBundle">
						마이페이지
					  </router-link>
					  <router-link class="page-name" to="/">
					  	회원정보수정
					  </router-link> -->
				  </div>
				  
			  </div>
			  <div class="link-apply" v-if="!token">
				    <router-link to="/agencyShipping">
					    <el-button type="primary" style="background-color:#F7941D;border:none;">배송대행 신청</el-button>
				    </router-link>
			  </div>
			 <div class="link-apply" v-else>
			  		<router-link to="/agencyShipping">
					    <el-button type="primary" style="background-color:#F7941D;border:none;">배송대행 신청</el-button>
				    </router-link>
					<router-link to="/agencyShopping" style="margin-left: 10px;">
						<el-button type="primary" style="background-color:#F7941D;border:none;">구매대행 신청</el-button>
					</router-link>
			  </div>
		  </div>
		  <div class="link-wrap">
			  <router-link to="/documentSchedule" class="link-wrap-name">배송일정</router-link>
			  <!-- <div class="link-wrap-name" @click="onNav('/')">报价计算器</div> -->
			  <router-link to="/documentSize" class="link-wrap-name">사이즈조건표</router-link>
			  <div class="link-wrap-name" >
				  <a style="text-decoration: none;color: var(--font-color);" href="https://www.baidu.com/s?ie=utf-8&amp;f=3&amp;rsv_bp=1&amp;rsv_idx=1&amp;tn=baidu&amp;wd=%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%9F%A5%E8%AF%A2&amp;fenlei=256&amp;oq=46%2526lt%253B762790550597&amp;rsv_pq=a89e0d0601495234&amp;rsv_t=2b7di9ZqS4gSqGPcd5BvaXjTJlsLJAsvkQcGKMAPHgUS5W7aO1Uv6ymheHk&amp;rqlang=cn&amp;rsv_dl=ts_0&amp;rsv_enter=0&amp;rsv_btype=t&amp;inputT=5993&amp;rsv_sug3=5&amp;rsv_sug1=2&amp;rsv_sug7=100&amp;rsv_sug2=1&amp;prefixsug=%25E5%25BF%25AB&amp;rsp=0&amp;rsv_sug4=5993&amp;rsv_sug=1" target="_blank">중국택배조회</a>
			  </div>
			  <router-link to="/documentAddress" class="link-wrap-name">나의 중국주소</router-link>
			<!--  <router-link class="link-wrap-name"  to="/">
				交货时间表
			  </router-link>
			  <router-link class="link-wrap-name"  to="/">
			  	报价计算器
			  </router-link>
			  <router-link class="link-wrap-name"  to="/">
			  	尺寸条件表
			  </router-link>
			  <router-link class="link-wrap-name"  to="/">
			  	中国快递查询
			  </router-link>
			  <router-link class="link-wrap-name"  to="/">
			  	我的中国地址
			  </router-link> -->
		  </div>
		  
		  <div  style="margin: 20px 0 0 0;">
			<el-collapse v-model="activeNames" @change="handleChange">
			  <el-collapse-item title="개인 회원" name="1">
			<!-- 	  <div class="nav-mobile">
					  <div>시작하기</div>
					  <div>배송대행</div>
				  </div> -->
				<ul class="nav-mobile">
					<!-- <li @click="onNav('/documentStart')">
						
							시작하기
						
					</li>
					<li @click="onNav('/deliveryguide')">		
						배송대행
					</li>
					<li @click="onNav('/documentProcess')">
						직구정보				
					</li>
					<li @click="onNav('/deliveryPrice')">
						배송요금	
					</li>
					<li @click="onNav('/documentBenefit')">
						혜택
					</li> -->
					<li>
						<router-link to="/addService" class="mobile-link">부가 서비스</router-link>
					</li>
					<li>
						<router-link to="/documentAwards" class="mobile-link">수상/보도</router-link>
					</li>
					<li>
						<router-link to="/customsInfo" class="mobile-link">통관안내</router-link>
					</li>
					<li>
						<router-link to="/documentReview" class="mobile-link">회원리뷰</router-link>
					</li>
					<!-- <li @click="onNav('/teamMoney')">
						팀머니
					</li>	 -->
				</ul>
			  </el-collapse-item>
			  <el-collapse-item title="사업자 회원" name="2">
			    <ul class="nav-mobile">
					<li>
						<router-link to="/bizSupport" class="mobile-link">사업자 지원 안내</router-link>
					</li>
					<li>
						<router-link to="/bizDeliveryGuide" class="mobile-link">배송대행</router-link>
					</li>
					<li>
						<router-link to="/shoppingGuide" class="mobile-link">구매대행</router-link>
					</li>
					<li>
						<router-link to="/deliveryPriceBiz" class="mobile-link">배송요금</router-link>
					</li>
					<li>
						<router-link to="/inventoryGuide" class="mobile-link">재고/보관</router-link>
					</li>
					<li>
						<router-link to="/bizAddService" class="mobile-link">부가서비스</router-link>
					</li>
					<li>
						<router-link to="/payGuide" class="mobile-link">대리결제</router-link>
					</li>
					<li>
						<router-link to="/bizCustomsInfo" class="mobile-link">통관안내</router-link>
					</li>
					<li>
						<router-link to="/documentLcl" class="mobile-link">LCL화물운송</router-link>
					</li>
					<li>
						<router-link to="/bizTeamMoney" class="mobile-link">팀머니</router-link>
					</li>
				<!-- 	<li @click="onNav('/')">
						한국 3PL
					</li> -->					
				</ul>
			  </el-collapse-item>
			  <el-collapse-item title="고객센터" name="3">
				<ul>
					<li>
						<router-link to="/noticeList" class="mobile-link">공지사항</router-link>
					</li>
					<li>
						<router-link to="/questionList" class="mobile-link">자주하는 질문</router-link>
					</li>
					<li>
						<router-link to="/oneConsult" class="mobile-link">1:1 문의</router-link>
					</li>
					<li>
						<router-link to="/documentInsure" class="mobile-link">안심보상</router-link>
					</li>
					<li>
						<router-link to="/boardEvent" class="mobile-link">이벤트</router-link>
					</li>
					<li>
						<router-link to="/partnership" class="mobile-link">제휴</router-link>
					</li>
					
					
				</ul>
			  </el-collapse-item>
			   <el-collapse-item title="Coupang" name="4">
				<ul>
					<li>
						<router-link to="/inventoryCoupang" class="mobile-link">그로스/로켓</router-link>
					</li>
					
					
				</ul>
			  </el-collapse-item>
			
			</el-collapse>  
		  </div>
		  



		</el-dialog>
		
	</div>
	



	

	


</template>

<script>
import { safePush } from '@/utils/router';
import { mapState, mapGetters,mapMutations } from 'vuex';
export default {
	data() {
	  return {
		activeIndex: '',//2-1
		centerDialogVisible: false,
		activeNames: ['1'],
		isScrolled: false,
		isHovered: false
		// token:'',
		// nickname:''
	  };
	},
	
	computed: {
	  isMobile() {
	    return window.innerWidth <= 768;
	  },
	   // 映射 state 到计算属性
	  ...mapState(['token', 'nickname']),
	  // 映射 getters
	  ...mapGetters(['isLoggedIn', 'userNickname']),
	},
	methods: {
		...mapMutations(['SET_TOKEN', 'SET_NICKNAME', 'CLEAR_USER']),
		handleCommand(command) {
			if(command == "logout"){
				this.onLogout();
			}
			
		  },
		onLogin(){
			// this.centerDialogVisible = false
			//this.$router.push('/login');
			safePush(this.$router, '/login');
		},
		onLogout(){
			this.CLEAR_USER();
			// localStorage.removeItem('token');
			// localStorage.removeItem('nickname');
			this.$router.push('/login');
		},
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
		  handleChange(val) {
			console.log(val);
		  },
		  onOrderBundle(url){
			  // this.centerDialogVisible = false
			  safePush(this.$router, url);
		  },
		  onNav(url){
			  // this.centerDialogVisible = false
			  safePush(this.$router, url);
		  },
		  handleScroll() {
			  this.isScrolled = window.scrollY > 50;
		  }
	},
	watch: {
		$route() {
			this.centerDialogVisible = false;
		}
	},
	mounted(){
		// this.token = localStorage.getItem('token')
		// this.nickname = localStorage.getItem('nickname')
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	}
  }
</script>

<style scoped>
	.header-container {
		position: sticky;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		background-color: #ffffff;
		transition: background-color 0.3s ease, box-shadow 0.3s ease;
		box-shadow: 0 2px 10px rgba(0,0,0,0.05);
	}
	.header-container.is-home {
		position: fixed;
		background-color: transparent;
	}
	.header-container.is-scrolled,
	.header-container:hover {
		background-color: #ffffff !important;
		box-shadow: 0 4px 12px rgba(0,0,0,0.1);
	}
	
	/* Default Menu Text Color */
	.header-container .menu {
		color: #1E3A5F;
		transition: color 0.3s ease;
	}
	.header-container ::v-deep .el-submenu__title i {
		color: #1E3A5F;
		transition: color 0.3s ease;
	}

	/* Home Page Initial State (White text on transparent) */
	.header-container.is-home:not(.is-scrolled):not(:hover) .menu {
		color: #fff;
	}
	.header-container.is-home:not(.is-scrolled):not(:hover) ::v-deep .el-submenu__title i {
		color: #fff;
	}
	.header-container.is-home:not(.is-scrolled):not(:hover) ::v-deep .el-button:not(.el-button--primary) {
		color: #fff;
		border-color: #fff;
		background-color: transparent;
	}
	
	.header-container:hover .menu,
	.header-container:hover ::v-deep .el-submenu__title i,
	.header-container:hover ::v-deep .el-submenu__title {
		color: #1E3A5F !important;
	}

	.header-container ::v-deep .el-menu.el-menu--horizontal,
	.header-container ::v-deep .el-menu--horizontal > .el-menu-item,
	.header-container ::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
		background-color: transparent !important;
		border-bottom: none !important;
		transition: color 0.3s ease, background-color 0.3s ease;
	}
	
	/* Submenu Dropdown Styling (when popper-append-to-body="false") */
	.header-container ::v-deep .el-menu--horizontal .el-menu {
		background-color: #ffffff !important;
		border: 1px solid #eee;
		box-shadow: 0 4px 12px rgba(0,0,0,0.1);
	}

	.header-container ::v-deep .el-menu--horizontal > .el-menu-item:hover,
	.header-container ::v-deep .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
		background-color: transparent !important;
		color: #F7941D !important;
	}

	.nav{
		display: flex;
		align-items: center;
		justify-content:space-between;
		padding:10px 50px;
		flex-wrap:nowrap;
	}
	.menu{
		font-weight: bold;font-size: 22px !important;width: 300px;text-align: center;
	}
	.menu-link {
		text-decoration: none;
		color: inherit;
		display: block;
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 2;
		font-size: 18px;
	}
	.mobile-link {
		text-decoration: none;
		color: #909399;
		display: block;
		width: 100%;
		padding: 8px 5px;
		position: relative;
		z-index: 2;
		font-size: 18px;
	}
	.el-menu.el-menu--horizontal{
		border-bottom:none;
	}
	/* 右上角关闭弹框按钮 */
	.el-icon-close{
		font-size: 30px;
	}

	
	@media (max-width: 768px) {
		.user-wrap{
			border: 1px solid var(--border-color);
			border-radius: 10px;
			padding: 15px;
			background: #fff;
			position: relative;
			margin: 16px 8px 10px;
		}
		.status-guest{
/* 			display: flex;
			justify-content: space-between; */
			border-bottom: 1px solid var(--border-color);
		}
		.user-wrap .name{
			font-size: 18px;
			/* padding-left: 26px; */
			position: relative;
			margin-bottom: 20px;
			
		
		}
		.user-wrap .logout{
			font-size: 16px;
		}
		.link-name{
			color: #000;text-decoration: none; 
		}
		.link-apply{
			padding-top: 20px;
			display: flex;
			justify-content: center;
		}
		.mypage{
			border: 1px solid var(--border-color);
			height: 40px;
			border-radius: 10px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 20px;
			padding: 0 50px;
		}
		.page-name{
			color: var(--font-color);
			text-decoration: none;
			height: 100%;
			flex: 0 0 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
		}
		.link-wrap{
			border-radius: 10px;
			border: 1px solid var(--border-color);
			background: #fff;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			padding:5px;
			margin: 20px 0;
		}
		.link-wrap-name{
			color: var(--font-color);
			text-decoration: none;
			padding: 5px 10px;
		}
		
		/* 修复 Dialog 溢出 */
		::v-deep .el-dialog.mobile-drawer {
			padding: 0 !important;
			overflow-x: hidden;
		}
		::v-deep .el-dialog.mobile-drawer .el-dialog__body {
			padding: 20px 10px !important;
			overflow-x: hidden;
		}
		
		/* 折叠面板 */
		.el-collapse-item__header{
			font-size: 18px;
			font-weight: bold;
		}
		.el-collapse{
			border-top: none;
		}
		.nav-mobile{
			display: flex;
			flex-wrap: wrap;
			list-style: none;
			
		}
		.nav-mobile li{
			width: 50%;
		}
		
	}
	
</style>

<style>
	/* Global styles to target Element UI dropdowns appended to body */
	.el-menu--horizontal .el-menu .el-menu-item:hover,
	.el-menu--horizontal .el-menu .el-submenu__title:hover {
		background-color: transparent !important;
		text-decoration: underline !important;
		text-underline-offset: 5px;
		color: #F7941D !important;
	}
	
	.el-menu--horizontal .el-menu .el-menu-item,
	.el-menu--horizontal .el-menu .el-submenu__title {
		transition: all 0.2s ease;
		font-size: 18px;
	}
</style>